module.exports = __webpack_public_path__ + "fonts/WorkSans-Regular.9773c0f.eot";